export type PRESENTATION_STATE_UPDATE_TYPE = 'REVISE' | 'VISIT' | 'CONFORM' | 'SEEN' | 'CANCEL';
export const PRESENTATION_STATE_UPDATE_TYPES = {
    REVISE: 'REVISE',
    VISIT: 'VISIT',
    CONFORM: 'CONFORM',
    SEEN: 'SEEN',
    CANCEL: 'CANCEL'
} as const;

export enum PRESENTATION_STATE {
    BORRADOR = 1,
    RECIBIDO = 2, //antes era presentado
    EN_REVISION = 3,
    PENDIENTE_VISITA = 4,
    PRESENTADO = 5, //antes era conformado
    CANCELADO = 6,
    PROCESANDO = 7,
    ERROR_PROCESAMIENTO = 8,
    VISADO = 9,
    INACTIVO = 10 //antes era PENDIENTE_RGRL
}

export enum ESTABLISHMENT_PRESENTATION_TABS {
    ACTIVE = 0,
    DRAFTS = 1,
    HISTORY = 2
}

export const ESTABLISHMENT_PRESENTATION_TAB_QUERY_PARAMS: Record<
    ESTABLISHMENT_PRESENTATION_TABS,
    Record<string, unknown>
> = {
    [ESTABLISHMENT_PRESENTATION_TABS.ACTIVE]: { estado: 'activos' },
    [ESTABLISHMENT_PRESENTATION_TABS.DRAFTS]: { estado: 'borrador' },
    [ESTABLISHMENT_PRESENTATION_TABS.HISTORY]: { estado: 'historial' }
};

// Mapping between update types and presentation states
export const PRESENTATION_STATE_UPDATE_MAP: Record<typeof PRESENTATION_STATE_UPDATE_TYPES[keyof typeof PRESENTATION_STATE_UPDATE_TYPES], PRESENTATION_STATE> = {
    REVISE: PRESENTATION_STATE.EN_REVISION,
    VISIT: PRESENTATION_STATE.PENDIENTE_VISITA,
    CONFORM: PRESENTATION_STATE.PRESENTADO,
    SEEN: PRESENTATION_STATE.VISADO,
    CANCEL: PRESENTATION_STATE.CANCELADO
};



export enum PRESENTATION_TYPE {
    RGRL_351 = 1,
    RGRL_617 = 2,
    RGRL_911 = 3,
    RAR = 4,
    CANCERIGENOS = 5
}

// El contrato queda inactivo al darlo de baja, junto con sus organismos y
// establecimientos, pero sus presentaciones RGRL/RAR/SVCC siguen debiendo
// verse y descargarse — solo se les quita la posibilidad de edición.
export const isContratoInactivo = (item: any): boolean => item?.contrato?.activo === false;

export enum RESPONSEOPTIONS {
    SI = 'SI',
    NO = 'NO',
    NA = 'N/A'
}

export type ALERT_TYPE =
    | 'CONFIRM_REVISE'
    | 'CONFIRM_VISIT'
    | 'CONFIRM_CONFORM'
    | 'CONFIRM_CANCEL'
    | 'CONFIRM_SEEN';

const ALERT_TYPES = {
    CONFIRM_REVISE: 'CONFIRM_REVISE',
    CONFIRM_VISIT: 'CONFIRM_VISIT',
    CONFIRM_CONFORM: 'CONFIRM_CONFORM',
    CONFIRM_SEEN: 'CONFIRM_SEEN',
    CONFIRM_CANCEL: 'CONFIRM_CANCEL'
};

const ALERT_TITLES = {
    [ALERT_TYPES.CONFIRM_REVISE]:
        'Si cambias una presentación en estado “Recibido” ya no podrás volver a este estado. Solo podrás utilizar los estados disponibles en las opciones.',
    [ALERT_TYPES.CONFIRM_VISIT]:
        'Si cambias una presentación en estado “Recibido” ya no podrás volver a este estado. Solo podrás utilizar los estados disponibles en las opciones.',
    [ALERT_TYPES.CONFIRM_CONFORM]:
        'Si cambias una presentación en estado “Recibido” ya no podrás volver a este estado. Solo podrás utilizar los estados disponibles en las opciones.',
    [ALERT_TYPES.CONFIRM_SEEN]:
        'Si cambias una presentación en estado “Recibido” ya no podrás volver a este estado. Solo podrás utilizar los estados disponibles en las opciones.',
    [ALERT_TYPES.CONFIRM_CANCEL]: 'Estás seguro de que deseas rechazar la presentación?'
};

const ALERT_CONFIRM_ACTIONS = {
    [ALERT_TYPES.CONFIRM_REVISE]: PRESENTATION_STATE_UPDATE_TYPES.REVISE,
    [ALERT_TYPES.CONFIRM_VISIT]: PRESENTATION_STATE_UPDATE_TYPES.VISIT,
    [ALERT_TYPES.CONFIRM_CONFORM]: PRESENTATION_STATE_UPDATE_TYPES.CONFORM,
    [ALERT_TYPES.CONFIRM_SEEN]: PRESENTATION_STATE_UPDATE_TYPES.SEEN,
    [ALERT_TYPES.CONFIRM_CANCEL]: PRESENTATION_STATE_UPDATE_TYPES.CANCEL
};

export { ALERT_TYPES, ALERT_TITLES, ALERT_CONFIRM_ACTIONS };
